import * as types from '../actions/action_types';

import { Map } from 'immutable';
import { StoreRecord } from '../records/store_records.js';
import { setValue } from './helpers.js';

export const initialState = Map({
    vendorTraceFilters: new StoreRecord({ value: {} }),
    vendorTracePrevalenceFilter: new StoreRecord({ value: [0, 100] }),
    isCollapseChildren: new StoreRecord({ value: false }),
    consentTypeFilter: new StoreRecord({ value: '' }),
    maxTraceLevel: new StoreRecord({ value: null }),
    searchByVendorNameMode: new StoreRecord({ value: 'allVendors' }),
    priorToConsentFilterList: new StoreRecord({ value: [true, false]}),
});

export default (state = initialState, action) => {
    switch (action.type) {
        case types.SET_SELECTED_VENDOR_TRACE_FILTERS:
            return setValue(state, ['vendorTraceFilters'], action.vendorTraceFilters);

        case types.SET_SELECTED_VENDOR_TRACE_PREVALENCE_FILTER:
            return setValue(state, ['vendorTracePrevalenceFilter'], action.vendorTracePrevalenceFilter);

        case types.SET_IS_COLLAPSE_CHILDREN:
            return setValue(state, ['isCollapseChildren'], action.isCollapseChildren);

        case types.SET_CONSENT_TYPE_FILTER:
            return setValue(state, ['consentTypeFilter'], action.consentTypeFilter);

        case types.SET_MAX_TRACE_LEVEL:
            return setValue(state, ['maxTraceLevel'], action.maxTraceLevel);

        case types.SET_SEARCH_BY_VENDOR_NAME_MODE:
            return setValue(state, ['searchByVendorNameMode'], action.searchByVendorNameMode);

        case types.SET_PRIOR_TO_CONSENT_FILTER_LIST:
            return setValue(state, ['priorToConsentFilterList'], action.priorToConsentFilterList);

        case types.RESET_VENDOR_TRACE:
            return initialState;
    }
    return state;
}
